import { useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { toast } from 'react-toastify'
import { countries } from 'country-list-json'
import ReCAPTCHA from 'react-google-recaptcha'
import * as yup from 'yup'
import apiservice from '../../../common/services/apiService'
import { useRouter } from 'next/router'
import { hideFormLoader, showFormLoader } from '../../../actions'
import { useDispatch } from 'react-redux'

const GetBusinessModal = ({ show, handleClose }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const sitekey = process.env.NEXT_PUBLIC_RECAPTCHA
  const reCaptchaRef = useRef(null)
  const [isHuman, setIsHuman] = useState('')
  // const [isHuman, setIsHuman] = useState(false)
  const [captchaError, setCaptchaError] = useState('')

  let getTheme = 'light'
  if (typeof window !== 'undefined') {
    getTheme = localStorage.getItem('Theme')
  }

  const validateCAPTCHA = async (token) => {
		setIsHuman(token);
    // const captchaRes = await axios.post(`/api/validateCaptcha`, {
    //   token: token,
    // })
    // if (captchaRes.status === 200) {
    //   setIsHuman(captchaRes.data.success)
    //   setCaptchaError('')
    // } else {
    //   setIsHuman(false)
    //   setCaptchaError('Invalid captcha.')
    // }
  }

  const handleSubmit = async (formData, e) => {
    // if(!isHuman) {
    //   setCaptchaError('Invalid captcha.')
    //   setIsHuman(false)
    //   return false
    // }
    dispatch(showFormLoader())
    setCaptchaError('')
    let data = {
      ...formData,
      captcha_token_v2: isHuman,
      page_link: window.location.href,
      page_title: document.title
    }
    e.resetForm()
    setIsHuman('')
    // setIsHuman(false)
    reCaptchaRef.current.reset()
    const lst = await apiservice.post('business-model', {data})
    dispatch(hideFormLoader())
    if (lst.data.success) {
      router.push('/thank-you')
      handleClose()
    } else {
      toast.error(lst.data.message)
    }
  }

  return (
    <Modal
      id="form-modal-open"
      size="lg"
      show={show}
      onHide={handleClose}
      className="modal-form business-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Get business model</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          name: '',
          business_email: '',
          industry: '',
          company_name: '',
          designation: '',
          country_name: '',
          message: '',
        }}
        validationSchema={yup.object({
          name: yup.string().required('Name is required.'),
          business_email: yup
            .string()
            .email('Email is not valid.')
            .required('Email is required.'),
          industry: yup.string().required('Industry is required.'),
          company_name: yup.string().required('Company Name is required.'),
          designation: yup.string().required('Designation is required.'),
          country_name: yup.string().required('Country Name is required.'),
          message: yup.string().required('Message is required.'),
        })}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <Modal.Body>
              <div className="modal-banner-section">
                <div className="modal-banner-content">
                  <h2>
                    We believe in connecting personally, kindly drop your
                    details below and we will connect with you soon on your
                    email with precise information you requested.
                  </h2>
                </div>
              </div>

              <div className="request-form">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Name *
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Enter Name"
                      />
                      <ErrorMessage
                        name="name"
                        component="span"
                        style={{ color: 'red' }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="business_email" className="form-label">
                        Business Email *
                      </label>
                      <Field
                        type="email"
                        className="form-control"
                        name="business_email"
                        placeholder="Enter Business Email"
                      />
                      <ErrorMessage
                        name="business_email"
                        component="span"
                        style={{ color: 'red' }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="industry" className="form-label">
                        Industry *
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="industry"
                        placeholder="Enter Industry"
                      />
                      <ErrorMessage
                        name="industry"
                        component="span"
                        style={{ color: 'red' }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="company_name" className="form-label">
                        Company Name *
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="company_name"
                        placeholder="Enter Company Name"
                      />
                      <ErrorMessage
                        name="company_name"
                        component="span"
                        style={{ color: 'red' }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="designation" className="form-label">
                        Designation *
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="designation"
                        placeholder="Enter Designation"
                      />
                      <ErrorMessage
                        name="designation"
                        component="span"
                        style={{ color: 'red' }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="form-group">
                      <label htmlFor="country_name" className="form-label">
                        Country *
                      </label>
                      <Field
                        as="select"
                        name="country_name"
                        id="country_name"
                        className="form-select"
                      >
                        <option value="">Select Country</option>
                        {countries.length
                          ? countries.map((country) => (
                              <option value={country.name} key={country.code}>
                                {country.name}
                              </option>
                            ))
                          : null}
                      </Field>
                      <ErrorMessage
                        name="country_name"
                        component="span"
                        style={{ color: 'red' }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <label for="message" className="form-label">
                        Message *
                      </label>
                      <Field
                        as="textarea"
                        type="text"
                        className="form-control"
                        name="message"
                        id="message"
                        placeholder="Your Requirements"
                      />
                      <ErrorMessage
                        name="message"
                        component="span"
                        style={{ color: 'red' }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12">
                    <div className="form-group mb-0 modal-recaptcha">
                      <ReCAPTCHA
                        theme={getTheme}
                        sitekey={sitekey}
                        ref={reCaptchaRef}
                        onChange={validateCAPTCHA}
                      />
                    </div>
                    <span style={{ color: 'red' }} >{captchaError}</span>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="modal-footer-inner">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => handleClose()}
                >
                  Close
                </button>
                <button
                  type="submit"
                  value="Submit"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default GetBusinessModal
